import { useQuery } from "@tanstack/react-query";

import axios from "../../../../../utils/axiosInceptor";
import { dashboardApiV1Endpoint } from "../../../../../api/v1/endpoints";
import { renewalCardsData } from "../utilis";

const getRenewalCards = async (body) => {
  const url = `${dashboardApiV1Endpoint}/dashboard/total-renewals-count`;
  const response = await axios.post(url, body);
  return response?.data?.result;
};

export const useGetRenewalsCard = (filterData) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["renewal-card", filterData?.queryParams],
    queryFn: () => getRenewalCards(filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });

  let renewalCard = data ? renewalCardsData(data[0]) : renewalCardsData(null);
  return {
    renewalCardData: renewalCard,
    isLoading: isLoading,
  };
};
